import React, { useCallback, useState, useEffect, useRef } from 'react';
import './style.css';
import { Layout, Breadcrumb, Popconfirm, Button, Form, Input, Row, Col, Pagination, Carousel } from 'antd';
import { MinusCircleOutlined, PlusOutlined, EditOutlined, DeleteOutlined, InboxOutlined, ArrowRightOutlined, ArrowLeftOutlined, CaretRightOutlined, CaretLeftOutlined } from '@ant-design/icons';
import FormBuilder from 'antd-form-builder'
import { getClerkDistributionList } from './ClerkDashboardSlice';
import Container from '../../../Layout/Container';
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { Link } from 'react-router-dom';
const { Header, Content, Footer } = Layout;



export default function ClerkDistributionList(props) {

  const formRef = useRef(null);
  const [pending, setPending] = useState(false)
  const dispatch = useDispatch();
  const [state, setState] = useState({});

  const [BackwardBtnStatus, setBackwardBtnStatus] = useState(true);
  const [ForwardBtnStatus, setForwardBtnStatus] = useState(false);
  const [page, setPage] = useState(1);

  const [form] = Form.useForm()
  let nav = useRef(null);

  const checkUUid = (listInfo) => {
    let listExplode = listInfo.uuid.split('-');
    let listJoin = listExplode.join('')
    let listname = 'dist_id_' + listJoin;
    setState(prev => ({
      ...prev,
      [listname]: listInfo.uuid
    }));

  }


  const getUpdateMeta = (listInfo) => {
    const meta = {
      disabled: pending,
      initialValues: listInfo,
      fields: [
        {
          key: 'bd_listContent',
          renderView: (v) => {

            return (
              <>
                <h2 className="distribution-list-title">
                  <span className="distribution-list-title-name">{listInfo.name}</span>
                  <span className="distribution-list-edit-dlt-btns">

                    {() => <button type="link" onClick={() => {
                      checkUUid(listInfo);
                    }}><EditOutlined /></button>}


                  </span>
                </h2>

                <ul className="distribution-list-ul">{
                  listInfo.listContent.map((v, i) => {
                    return (
                      <li key={i}>{v}</li>
                    )
                  })
                }</ul>
              </>
            )
          },
          widget: () => {
            let bdrref = [];

            if (listInfo.listContent) {
              bdrref.push({ listContent: listInfo.name })
              listInfo.listContent.forEach(v => {
                bdrref.push({ listContent: v })

              });
              // console.log(bdrref);
            }

            let elistExplode = listInfo.uuid.split('-');
            let elistJoin = elistExplode.join('')
            let elistname = 'listid_' + elistJoin;

            return (
              <>
                <Form.List name="arr_listContent" key={listInfo.uuid} initialValue={bdrref}>
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, fieldKey, ...restField }) => (
                        <Form.Item
                          {...restField}
                          name={[name, "listContent"]}
                          label={
                            key == 0 ? (
                              <Button className="distribution-list-addmore-button" onClick={() => add()} type="link">+ Add More</Button>
                            ) : (
                              <Button className="distribution-list-remove-input-button" onClick={() => remove(name)} type="link"><MinusCircleOutlined /></Button>
                            )
                          }
                          fieldKey={[fieldKey, "listContent"]}
                          rules={[{ required: true, message: "List is required" }]}
                          requiredMark={"optional"}
                          className="distribution-list-input-box"
                        >
                          <Input className="formInput" placeholder="Add Name" onClick={(e) => { return true; }} />
                        </Form.Item>
                      ))}
                    </>
                  )}
                </Form.List>
              </>
            )
          },

        },
      ],
    }
    return meta
  }


  const handleOnClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
  }

  const onClickBackward = () => {
    if (page > 1) {
      setBackwardBtnStatus(false);
      setForwardBtnStatus(false);
      let p = page - 1;
      setPage(p)
      // console.log("backward= ", p);
      dispatch(getClerkDistributionList(p));
    }
    else {
      setBackwardBtnStatus(true);
      setForwardBtnStatus(false);
    }
  }

  const onClickForward = () => {

    if (Math.ceil(props.listcount / 5) > page) {
      let p = page + 1;
      setPage(p)
      // console.log("Forward= ", p);
      dispatch(getClerkDistributionList(p));
      setBackwardBtnStatus(false);
      setForwardBtnStatus(false);
    }
    else {
      setForwardBtnStatus(true);
      setBackwardBtnStatus(false);
    }

  }

  return (
    <>
      {/* 
      <div className="site-layout-content bg-white" style={{ marginTop: 0, paddingTop: 0 }}>


        <Form
          ref={formRef}
          layout="vertical"
          labelCol={{ span: 16 }}
          wrapperCol={{ span: 24 }}
          className="distribution-list-form "
          style={{ marginTop: '20px' }}
        >
          <Carousel
            slidesToShow={props.listdata.length <= 5 ? props.listdata.length == 0 ? props.listdata.length + 1 : props.listdata.length : 5}
            centerMode={true}
            //asNavFor={media}
            draggable={false}
            ref={(carousel) => (nav = carousel)}
            swipeToSlide={true}
            touchThreshold={50}
            focusOnSelect={true}
            dots={false}
            infinite={true}
            swipeToSlide={true}
            arrows
            nextArrow={<ArrowRightOutlined />}
            prevArrow={<ArrowLeftOutlined />}
            // style={{zIndex:1111}}
            className={props.listdata.length < 5 ? "distribution-list-carousel" : ""}
          >
            {props.listdata && props.listdata.map(function (v, i) {
              let listdExplode = v.uuid.split('-');
              let listdJoin = listdExplode.join('')
              let listdname = 'dist_id_' + listdJoin;
              return (

                <div key={v.uuid} onClick={e => handleOnClick(e)} >

                  <Form.Item>
                    <Form.Item name={"list_name"} hidden={true} initialValue={v.name}>
                      <Input className="formInput" placeholder="" />
                    </Form.Item>


                    <FormBuilder form={form} getMeta={() => getUpdateMeta(v)} viewMode={state && state[listdname] == v.uuid ? false : true} />

                  </Form.Item>

                </div>
              );
            })}
          </Carousel>
        </Form>

        {
          (props.listcount <= 0) &&
          <Row className="no-distributionlist-item-found" gutter={[10, 0]} style={{ padding: '25px 30px 10px 30px', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8', position: 'relative' }}>
            <Col span="24" style={{ textAlign: 'center', padding: '50px' }}>
              <InboxOutlined />
              <h2>No distribution list have been added yet!</h2>
            </Col>
          </Row>
        }
      </div> */}



      <div className="all-forms-wrapper-distribution-list" >
        {
          (props.listcount > 0) &&
          <button className='prev-next-btns' onClick={onClickBackward} disabled={BackwardBtnStatus}><CaretLeftOutlined /></button>
        }
        {props.listdata && props.listdata.map(function (v, i) {
          let listdExplode = v.uuid.split('-');
          let listdJoin = listdExplode.join('')
          let listdname = 'dist_id_' + listdJoin;
          return (

            <Form
              key={v.uuid}
              // ref={formRef}
              ref={state && state[listdname] == v.uuid ? formRef : null}
              layout="vertical"
              labelCol={{ span: 16 }}
              wrapperCol={{ span: 24 }}
              // onFinish={handleFinishUpdate}
              // onFinish={(values) => this.handleFinishUpdate(values)}
              className="distribution-list-form "
              style={{ paddingTop: '20px', backgroundColor: "#ffffff" }}
            >
              <div key={v.uuid} onClick={e => handleOnClick(e)}>

                <Form.Item>
                  <Form.Item name={"list_name"} hidden={true} initialValue={v.name}>
                    <Input className="formInput" placeholder="" />
                  </Form.Item>

                  <FormBuilder name="allData" key={v.uuid} form={form} getMeta={() => getUpdateMeta(v)} viewMode={state && state[listdname] == v.uuid ? false : true} />

                  {/* {state && state[listdname] == v.uuid && (
                    <Form.Item className="form-footer" wrapperCol={{ span: 24, offset: 0 }}>

                      <Button className="list-save-btn" type="primary" onClick={() => formRef.current.submit()} disabled={pending}>
                        {pending ? "Updating..." : "Save"}
                      </Button>
                      <Button className="list-cancel-btn"
                        onClick={() => {
                          removeCheckedUUid(v)
                        }}
                        style={{ marginLeft: "15px" }}
                      >
                        Cancel
                      </Button>
                    </Form.Item>
                  )} */}
                </Form.Item>

              </div>
            </Form>
          );
        })}
        {
          (props.listcount > 0) &&
          <button className='prev-next-btns' onClick={onClickForward} disabled={ForwardBtnStatus}><CaretRightOutlined /></button>
        }
        {
          (props.listcount <= 0) &&
          <Row className="no-distributionlist-item-found" gutter={[10, 0]} style={{ backgroundColor: "#ffffff", padding: '25px 30px 10px 30px', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8', position: 'relative' }}>
            <Col span="24" style={{ textAlign: 'center', padding: '50px' }}>
              <InboxOutlined />
              <h2>No distribution list have been added yet!</h2>
              <h2>Click on <span>"Add List"</span> to start adding the branches</h2>
            </Col>
          </Row>
        }
      </div>



    </>
  );
}